import React from 'react';
import styles from './CharacterProfile.module.css';

/**
 * MatureTag component to display an 'M' with a circular white background
 * Indicates that a character is for mature audiences
 */
const MatureTag: React.FC = () => {
  return (
    <div className={styles.matureTagContainer}>
      <div className={styles.matureTag}>
        <span className={styles.matureTagText}>M</span>
      </div>
      <div className={styles.matureTooltip}>
        This character is for mature audiences
      </div>
    </div>
  );
};

export default MatureTag; 